import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { roleBasedUrl } from '../../helpers';
import { logout } from '../../auth';
import Dropdown from './Dropdown';
import '../../i18n';
import { useTranslation } from 'react-i18next';
import logo from '../../images/logo6.png';
import { BOOKING_HUB_ROUTES } from '../../data/touristNavigation';

const navLinkClass =
	'link text-white navbar-top-nav-link mr-2 mr-md-3';

const isFlightsActive = (_, { pathname }) => pathname.startsWith('/flights');

const isBookTripActive = (_, { pathname }) =>
	[...BOOKING_HUB_ROUTES].some(
		(route) => route !== '/flights' && (pathname === route || pathname.startsWith(`${route}/`))
	);

const isGuidesActive = (_, { pathname }) =>
	pathname === '/guides' || pathname.startsWith('/guides/');

const isBookingsActive = (_, { pathname }) =>
	pathname === '/bookings' || pathname.startsWith('/bookings/');

const NavBar = ({ sideBarIsVisible, toggleSidebar, currentUser }) => {
	const loggedIn = currentUser.email !== undefined;
	const { t } = useTranslation();
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(typeof window !== 'undefined' && window.scrollY > 8);
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	return (
		<nav className={`navbar navbar-expand-lg navbar-dark bg-primary sticky-top navbar--minimal ${scrolled ? 'navbar--scrolled' : ''}`}>
			<div className="container navbar-container">
				<Link to="/" className="navbar-brand">
					<img src={logo} alt="Visit All Nepal" className="navbar-logo-img" />
				</Link>

				<div className="d-flex align-items-center navbar-actions ml-auto">
					<NavLink
						to="/flights"
						className={`${navLinkClass} navbar-flights-link navbar-flights-link--highlight d-inline-flex`}
						activeClassName="active"
						isActive={isFlightsActive}
						aria-label="Book Nepal domestic flights with your Visa or Mastercard"
					>
						<span className="navbar-flights-link__short">
							<span className="navbar-flights-link__icon" aria-hidden="true">
								✈
							</span>
							Flights
						</span>
						<span className="navbar-flights-link__full">
							<span className="navbar-flights-link__label">Domestic flights</span>
							<span className="navbar-flights-link__badge">Visa · MC</span>
						</span>
					</NavLink>
					<NavLink
						to="/book-experiences"
						className={`${navLinkClass} navbar-book-link d-none d-sm-inline-flex`}
						activeClassName="active"
						isActive={isBookTripActive}
						aria-label="Book treks and tours"
					>
						<span className="navbar-book-link__short" aria-hidden="true">Trips</span>
						<span className="navbar-book-link__full">Book a trip</span>
					</NavLink>
					<NavLink
						to="/guides"
						className={`${navLinkClass} navbar-guides-link d-none d-sm-inline-flex`}
						activeClassName="active"
						isActive={isGuidesActive}
						aria-label="Travel guides"
					>
						Travel Guide
					</NavLink>
					{currentUser.role && (currentUser.role === 'Admin' || currentUser.role === 'Vendor') && (
						<NavLink
							className="link text-white nav-link-dashboard mr-3 d-none d-md-inline-flex"
							to={roleBasedUrl(currentUser.role, '/')}
							activeClassName="active"
						>
							{t('Mydashboard') || 'Dashboard'}
						</NavLink>
					)}
					{loggedIn && (
						<div className="navbar-my-bookings-wrap d-none d-md-flex align-items-center">
							<span className="navbar-nav-pipe" aria-hidden="true" />
							<NavLink
								to="/bookings"
								className={`${navLinkClass} d-inline-flex mr-md-0`}
								activeClassName="active"
								isActive={isBookingsActive}
								aria-label="My bookings"
							>
								My Bookings
							</NavLink>
						</div>
					)}
					{loggedIn ? (
						<Dropdown
							icon="fas fa-user"
							title={currentUser.name || 'Account'}
							className="text-white pl-2 nav-dropdown navbar-user-dropdown"
						>
							<ul className="text-normal">
								<li className="m-0">
									<Link to="/bookings" className="item text-bold">My Bookings</Link>
								</li>
								<li className="m-0">
									<Link to={`/profile/${currentUser.idx}#profile`} className="item text-bold">{t('Profile')}</Link>
								</li>
								<li className="dropdown-menu-divider" role="separator" aria-hidden="true" />
								<li className="m-0">
									<button type="button" className="item text-bold nav-dropdown-logout-btn" onClick={logout}>
										{t('Logout')}
									</button>
								</li>
							</ul>
						</Dropdown>
					) : (
						<Link to="/login" className="navbar-login-link text-bold text-white" aria-label={t('Login')}>
							{t('Login')}
						</Link>
					)}
				</div>
			</div>
		</nav>
	);
};

const mapStateToProps = ({ userStore }) => ({
	currentUser: userStore.currentUser,
});

export default connect(mapStateToProps)(NavBar);
